module.exports = __webpack_public_path__ + "championsleague_square-c7aa52f717067f6881ea28697d6f267c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/championsleague_square.jpg
// module id = 1180
// module chunks = 1 2